import React, { useState } from "react";
import {
  verticalTemplatesList,
  horizontalTemplatesList,
  centeredTemplatesList,
} from "../../../../../services/Templates";

const templatePositions = [
  {
    key: "vertical",
    label: "Vertical",
    preview: (
      <img src="/template-vertical.svg" alt="Vertical" className="w-28 h-20" />
    ),
  },
  {
    key: "horizontal",
    label: "Horizontal",
    preview: (
      <img src="/template-top.svg" alt="Horizontal" className="w-28 h-20" />
    ),
  },
  {
    key: "centered",
    label: "Centered",
    preview: (
      <img src="/template-centered.svg" alt="Centered" className="w-28 h-20" />
    ),
  },
];

export default function ChooseCtaTemplate({ onSelectedTemplate }) {
  const [selected, setSelected] = useState("vertical");

  return (
    <div className="bg-white overflow-y-auto p-4 sm:p-6 h-full">
      {/* Layout Selection */}
      <div className="mb-6 sm:mb-8">
        <h4 className="text-black text-base sm:text-lg font-semibold mb-4">
          Choose your template
        </h4>
        <div className="flex flex-wrap sm:flex-nowrap gap-3 sm:gap-4 justify-center sm:justify-start">
          {templatePositions.map((tpl) => (
            <div
              key={tpl.key}
              className={`cursor-pointer transition-all ${
                selected === tpl.key
                  ? "ring-2 ring-[#7700FF] ring-offset-2 ring-offset-white"
                  : "opacity-60 hover:opacity-100"
              }`}
              onClick={() => setSelected(tpl.key)}
            >
              <div className="bg-white rounded p-1 sm:p-2 mb-2">
                {tpl.preview}
              </div>
              <span className="text-black text-xs font-medium block text-center">
                {tpl.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Template Cards */}
      <div
        className={
          selected === "horizontal"
            ? "grid grid-cols-1 gap-3 sm:gap-4 lg:gap-6"
            : "grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 lg:gap-6"
        }
      >
        {selected === "vertical" &&
          verticalTemplatesList.map((tpl) => (
            <div
              key={tpl.key}
              onClick={() => onSelectedTemplate(tpl.key)}
              className="cursor-pointer transition-transform hover:scale-105"
            >
              <tpl.preview {...tpl.defaultValues} preview={true} />
            </div>
          ))}

        {selected === "horizontal" &&
          horizontalTemplatesList.map((tpl) => (
            <div
              key={tpl.key}
              onClick={() => onSelectedTemplate(tpl.key)}
              className="cursor-pointer transition-transform hover:scale-105"
            >
              <tpl.preview {...tpl.defaultValues} preview={true} />
            </div>
          ))}

        {selected === "centered" &&
          centeredTemplatesList.map((tpl) => (
            <div
              key={tpl.key}
              onClick={() => onSelectedTemplate(tpl.key)}
              className="cursor-pointer transition-transform hover:scale-105"
            >
              <tpl.preview {...tpl.defaultValues} preview={true} />
            </div>
          ))}
      </div>
    </div>
  );
}
